<template>
    <form id="ProfessionalExperienceForm" class="needs-validation" novalidate>
        <div class="row g-3">
            <!-- Employment Type Field -->
            <div class="col-md-4">
                <label for="employmentType"><strong>{{ $Translate('employmentType') }}: </strong><span
                        class="text-danger">*</span></label>
                <select class="form-control"
                    :class="{ 'is-valid': profExpSubmitted && employmentTypeIsValid, 'is-invalid': profExpSubmitted && !employmentTypeIsValid }"
                    id="employmentType" v-model="professionalExperience.employment" required>
                    <option value="" selected disabled>{{ $Translate('selectEmploymentType') }}</option>
                    <option value="Employee">{{ $Translate('employee') }}</option>
                    <option value="Unemployed">{{ $Translate('unEmployed') }}</option>
                </select>
            </div>

            <!-- UnEmployment Type Field -->
            <div class="col-md-4" v-if="professionalExperience.employment === 'Unemployed'">
                <label for="UnEmployment"><strong>{{ $Translate('UnEmploymentType') }}:
                    </strong><span class="text-danger">*</span></label>
                <select class="form-control"
                    :class="{ 'is-valid': profExpSubmitted && employerPositionIsValid, 'is-invalid': profExpSubmitted && !employerPositionIsValid }"
                    id="employerPosition" v-model="professionalExperience.employerPosition" required>
                    <option value="" selected disabled>{{ $Translate('selectUnEmploymentType') }}</option>
                    <option value="Job Seeker">{{ $Translate('jobSeeker') }}</option>
                    <option value="Fresh Graduate">{{ $Translate('freshGraduate') }}</option>
                </select>
            </div>

            <!-- Position Field -->
            <div class="col-md-4" v-if="professionalExperience.employment === 'Employee'">
                <label for="employerPosition"><strong>{{ $Translate('employerPosition') }}:
                    </strong><span class="text-danger">*</span></label>
                <input type="text" id="employerPosition" class="form-control"
                    :placeholder="$Translate('employerPositionPlaceholder')"
                    :class="{ 'is-valid': profExpSubmitted && employerPositionIsValid, 'is-invalid': profExpSubmitted && !employerPositionIsValid }"
                    v-model="professionalExperience.employerPosition" name="employerPosition" required />
            </div>

            <!-- Employer Name Field -->
            <div class="col-md-4" v-if="professionalExperience.employment === 'Employee'">
                <label for="nameOfEmployer"><strong>{{ $Translate('nameOfEmployer') }}: </strong><span
                        class="text-danger">*</span></label>
                <input type="text" id="nameOfEmployer" class="form-control"
                    :placeholder="$Translate('nameOfEmployerPlaceholder')"
                    :class="{ 'is-valid': profExpSubmitted && nameOfEmployerIsValid, 'is-invalid': profExpSubmitted && !nameOfEmployerIsValid }"
                    v-model="professionalExperience.nameOfEmployer" name="nameOfEmployer" required />
            </div>

            <!-- From Date Field -->
            <div class="col-md-4">
                <label for="startDateProfessionalExperience"><strong>{{ $Translate('startDate') }}:
                    </strong></label>
                <input type="date" id="startDateProfessionalExperience" class="form-control"
                    :class="{ 'is-valid': profExpSubmitted && startDateProfessionalExperienceIsValid, 'is-invalid': profExpSubmitted && !startDateProfessionalExperienceIsValid }"
                    v-model="professionalExperience.startDateProfessionalExperience"
                    name="startDateProfessionalExperience" required />
            </div>

            <!-- To Date Field -->
            <div class="col-md-4">
                <label for="endDateProfessionalExperience"><strong>{{ $Translate('endDate') }}:
                    </strong><span class="text-danger">*</span></label>
                <input type="date" id="endDateProfessionalExperience" class="form-control" :disabled="isChecked" :class="{
                    'is-valid': profExpSubmitted && endDateProfessionalExperienceIsValid,
                    'is-invalid': profExpSubmitted && !endDateProfessionalExperienceIsValid
                }" v-model="professionalExperience.endDateProfessionalExperience" />
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="present" :checked="isChecked"
                        @change="$emit('toggle-check', $event.target.checked)" />

                    <label class="form-check-label" for="present">
                        {{ $Translate('present') }}
                    </label>
                </div>
            </div>

            <!-- Description Field -->
            <div class="col-md-4">
                <label for="descriptionProfessionalExperience"><strong>{{ $Translate('description') }}:
                    </strong></label>
                <textarea id="descriptionProfessionalExperience" class="form-control"
                    :class="{ 'is-valid': profExpSubmitted && descriptionProfessionalExperienceIsValid, 'is-invalid': profExpSubmitted && !descriptionProfessionalExperienceIsValid }"
                    v-model="professionalExperience.descriptionProfessionalExperience"
                    name="descriptionProfessionalExperience" />
            </div>
        </div>
    </form>
</template>

<script>
export default {
    name: 'ProfessionalExperience',
    props: {
        professionalExperience: Object,
        profExpSubmitted: Boolean,
        professionalExperienceList: Array,
        isChecked: Boolean,
        employmentTypeIsValid: Boolean,
        employerPositionIsValid: Boolean,
        nameOfEmployerIsValid: Boolean,
        startDateProfessionalExperienceIsValid: Boolean,
        endDateProfessionalExperienceIsValid: Boolean,
        descriptionProfessionalExperienceIsValid: Boolean,
    }
}
</script>

<style scoped>
.col-md-4 {
    text-align: start;
}

.col-md-4 label {
    margin-bottom: 10px;
}

.col-md-4 input,
.col-md-4 select,
.col-md-4 textarea {
    margin-bottom: 12px;
}

.col-md-4 select {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background: url('../../../../dist/assets/select.svg') no-repeat right 0.75rem center;
    background-color: #fff;
    background-size: 16px 16px;
    padding-right: 2rem;
    line-height: 1.5;
    height: calc(1.5em + 0.75rem + 2px);
}
</style>